import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSocialIconsFacebook = function SvgSocialIconsFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "evenodd",
    d: "M.857 12c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12m13.1 7.19V12h2l.23-2.49h-2.23V8.28c0-.65.08-1 1-1h1.28V4.8h-2c-2.39 0-2.94 1.26-2.94 3.26v1.46h-1.81V12h1.81v7.19z",
    clipRule: "evenodd"
  })));
};

export { SvgSocialIconsFacebook as ReactComponent };
//# sourceMappingURL=social-icons-facebook.svg.esm.js.map
